/* holz4home · Über-uns Section-Paket — Scroll-Reveal
   Läuft nur einmal (Guard). Ohne JS bleiben Inhalte sichtbar
   (die versteckende CSS-Regel greift erst mit Klasse .u-anim). */
(function () {
  if (window.__ueberUnsInit) return;
  window.__ueberUnsInit = true;

  function init() {
    // Aktiviert erst jetzt die Reveal-Startzustände (No-JS = sichtbar)
    document.documentElement.classList.add('u-anim');

    var els = document.querySelectorAll('.u-rev');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
